import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepButton from '@mui/material/StepButton';
import Typography from '@mui/material/Typography';

const steps = [
  { label: 'Upload your document with names and addresses' },
  { label: 'Choose your desired label type' },
  { label: 'Download' },
];

export default function MUIStepper({ currentStep, setCurrentStep, file, outputFormat, avery }) {
  const isStepEnabled = (idx) => {
    if (idx === 0) return true;
    if (idx === 1) return !!file;
    if (idx === 2) return !!file && !!outputFormat && !!avery;
    return false;
  };
  return (
    <Stepper activeStep={currentStep - 1} alternativeLabel sx={{ width: '100%', margin: '2rem 0' }}>
      {steps.map((step, idx) => {
        const enabled = isStepEnabled(idx);
        const isActive = currentStep - 1 === idx;
        const isCompleted = currentStep > idx + 1;
        return (
          <Step key={step.label} completed={isCompleted} active={isActive} disabled={!enabled}>
            <StepButton
              onClick={() => enabled && setCurrentStep(idx + 1)}
              disabled={!enabled}
              sx={{
                pointerEvents: enabled ? 'auto' : 'none',
              }}
            >
              <StepLabel
                icon={
                  <span
                    style={{
                      display: 'inline-block',
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      background: isActive ? '#1976d2' : (isCompleted ? '#4caf50' : '#e0e0e0'),
                      color: enabled ? (isActive ? '#fff' : '#222') : '#aaa',
                      fontWeight: 600,
                      fontSize: 18,
                      lineHeight: '32px',
                      textAlign: 'center',
                      margin: '0 auto',
                      transition: 'background 0.2s, color 0.2s',
                    }}
                  >
                    {idx + 1}
                  </span>
                }
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: enabled ? (isActive ? '#1976d2' : '#222') : '#aaa',
                    fontWeight: enabled ? 500 : 400,
                    fontSize: 15,
                    mt: 1,
                  }}
                >
                  {step.label}
                </Typography>
              </StepLabel>
            </StepButton>
          </Step>
        );
      })}
    </Stepper>
  );
}

